import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { HolographicButton } from './HolographicButton';
const faqs = [{
  q: '¿Y si mi bebé es muy pequeño?',
  a: 'Hay protocolos desde los 0 meses.'
}, {
  q: 'Ya probé todo y nada funcionó',
  a: 'Lo que probaste fue hecho para otro país.'
}, {
  q: '¿Y si mi casa es muy ruidosa?',
  a: 'El Kit Noche Blindada es exactamente para eso.'
}, {
  q: 'No tengo tiempo de leer',
  a: 'Lo terminás en una siesta.'
}, {
  q: '¿Y si no funciona?',
  a: 'Garantía 7 días. Devolvemos el dinero.'
}, {
  q: '¿Es seguro para el bebé?',
  a: 'Basado en ciencia. Sin llanto controlado agresivo.'
}, {
  q: 'Mi pareja no va a aplicarlo',
  a: 'El Bono Paz en Pareja incluye guiones para eso.'
}, {
  q: '¿Y si se despierta y no sé qué hacer?',
  a: 'El Bono SOS 3:15 AM te da tarjetas de decisión.'
}, {
  q: '¿Y si la abuela interfiere?',
  a: 'Hay guía para manejar interferencias externas.'
}];
export function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-12 md:py-16 bg-warm-200" data-id="element-88">
      <div className="max-w-2xl mx-auto px-4" data-id="element-89">
        <h2 className="text-2xl md:text-3xl font-bold text-text-dark text-center mb-8" data-id="element-90">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-2 mb-8" data-id="element-91">
          {faqs.map((faq, idx) => <div key={idx} className={`bg-white rounded-xl overflow-hidden transition-all ${openIdx === idx ? 'shadow-md' : 'shadow-sm'}`} data-id="element-92">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full flex items-center justify-between p-4 text-left" data-id="element-93">
                <span className="font-medium text-text-dark text-sm pr-4" data-id="element-94">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-primary-500 shrink-0 transition-transform ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-95" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIdx === idx ? 'max-h-32 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-96">
                <div className="px-4 pb-4 text-sm text-text-body" data-id="element-97">{faq.a}</div>
              </div>
            </div>)}
        </div>

        <div className="bg-white p-6 rounded-2xl shadow-md text-center" data-id="element-98">
          <HolographicButton href="https://emalia.lat/cart/48344374509818:1" size="md" id="btn-compra-faq" data-id="element-99">
            Comprar $29.999
          </HolographicButton>
          <p className="text-xs text-text-muted mt-3" data-id="element-100">
            Acceso inmediato • Garantía 7 días • 3 bonos
          </p>
        </div>
      </div>
    </section>;
}